import { render } from "./CheckSignatureView.vue?vue&type=template&id=445e363b&scoped=true&ts=true"
import script from "./CheckSignatureView.vue?vue&type=script&lang=ts"
export * from "./CheckSignatureView.vue?vue&type=script&lang=ts"

import "./CheckSignatureView.vue?vue&type=style&index=0&id=445e363b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445e363b"]])

export default __exports__